import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EyeIcon } from "@heroicons/react/16/solid";
import { useSearchExport } from "../context/SearchExportContext";
import ExportDropdown from "../context/ExportDropdown";
import RecordsLoader from "../components/RecordsLoader";
import { getCampaigns } from "../redux/CampaignSlice";
import CampaignBatchModal from "../components/CampaignBatchesModal";

const CampaignAnalytics = () => {
  const dispatch = useDispatch();
  const { campaigns, status, pagination } = useSelector((state) => state.campaigns);
  const { totalCount } = pagination;
  console.log(totalCount,'totalcount')
  const { filterData } = useSearchExport();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [campaignBatches, setCampaignBatches] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [campaignName, setCampaignName] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const campaignsPerPage = 10;
  const [selectedType, setSelectedType] = useState("All");

  useEffect(() => {
    const offset = (currentPage - 1) * campaignsPerPage;
    const filters = {
      limit: campaignsPerPage,
      offset: offset,
    };
    if (selectedType !== "All") {
      filters.type = selectedType;
    }
    if (campaignName.trim()) filters.campaign_name = campaignName;
    if (selectedDate.trim()) filters.date = selectedDate;
    dispatch(getCampaigns(filters));
  }, [dispatch, campaignName, selectedDate, currentPage, selectedType]);

  const currentCampaigns = filterData(
    campaigns.filter((item) =>
      selectedType === "All" ? true : item.type === selectedType
    )
  );

  // const currentCampaigns = filterData(campaigns);

  const handleRowClick = (allBatches) => {
    setCampaignBatches(allBatches);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCampaignBatches(null);
  };

  return (
    <div className="container mx-auto p-6">
      {status === "idle" && (
        <RecordsLoader text="Loading campaigns, please hold on..." />
      )}

      <h1 className="text-2xl font-bold mb-6 text-black">Campaign Analytics</h1>

      {/* Filters Section */}
      <div className="mb-4 flex items-center gap-4">
        <input
          type="text"
          placeholder="Enter Campaign Name"
          value={campaignName}
          onChange={(e) => setCampaignName(e.target.value)}
          className="px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={() => {
            setCampaignName("");
            setSelectedDate("");
          }}
          className="bg-red-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-red-600"
        >
          Clear Filters
        </button>
      </div>

      {/* Export Buttons */}
      <ExportDropdown data={campaigns} fileName="campaigns" />

      <div className="mb-4 flex items-center gap-4">
        <button
          onClick={() => setSelectedType("All")} 
          className={`px-4 py-2 rounded-md ${
            selectedType === "All" ? "bg-blue-500 text-gray-50" : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          All
        </button>
        <button
          onClick={() => setSelectedType("EmailCampaign")} 
          className={`px-4 py-2 rounded-md ${
            selectedType === "EmailCampaign" ? "bg-blue-500 text-gray-50" : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          EmailCampaign
        </button>
        <button
          onClick={() => setSelectedType("ColdOutreachEmailJob")} 
          className={`px-4 py-2 rounded-md ${
            selectedType === "ColdOutreachEmailJob" ? "bg-blue-500 text-gray-50" : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          ColdOutreachEmailJob
        </button>
      </div>

      {status === "failed" && <p>Error loading campaigns</p>}

      {/* Campaigns Table */}
      {status === "succeeded" && (
        <>
          <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="px-4 py-2">Campaign Name</th>
                <th className="px-4 py-2">Total Emails</th>
                <th className="px-4 py-2">Success Rate</th>
                <th className="px-4 py-2">Failure Rate</th>
                <th className="px-4 py-2">Sent At</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
            {currentCampaigns.length > 0 ? (
              currentCampaigns.map((campaign) => {
                const lastBatch = Array.isArray(campaign.batches)
                  ? campaign.batches.at(-1)
                  : null;

                return (
                  <tr
                    key={campaign.campaign_id}
                    className="border-b hover:bg-gray-100"
                  >
                    <td className="px-4 py-2">
                      {campaign.campaign_name ? campaign.campaign_name : "NA"}
                    </td>
                    <td className="px-4 py-2">
                      {campaign.total_emails}
                    </td>
                    <td className="px-4 py-2 text-green-600 font-bold">
                      {campaign.success_count}
                      <span className="text-green-500 font-normal">
                        {" "}
                        ({campaign.success_percentage}%)
                      </span>
                    </td>
                    <td className="px-4 py-2 text-red-600 font-bold">
                      {campaign.failure_count}
                      <span className="text-red-500 font-normal">
                        {" "}
                        ({campaign.failure_percentage}%)
                      </span>
                    </td>
                    <td className="px-4 py-2">
                    {lastBatch
                      ? new Date(lastBatch.send_time).toLocaleString()
                      : new Date(campaign.send_time).toLocaleString()
                        ? new Date(campaign.send_time).toLocaleString()
                        : "Not Available"}
                    </td>
                    <td className="px-4 py-2 flex">
                      <EyeIcon
                        className="size-6 text-blue-500 ml-4"
                        onClick={() => handleRowClick(campaign.batches)}
                      />
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No campaigns found
                </td>
              </tr>
            )}
            </tbody>
          </table>

          {/* Pagination */}
          {totalCount > campaignsPerPage && (
            <div className="flex flex-wrap justify-center mt-6 gap-2 max-w-full">
              {Array.from(
                { length: Math.ceil(totalCount / campaignsPerPage) },
                (_, i) => i + 1
              ).map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-4 py-2 rounded-md text-sm font-medium ${
                    currentPage === page
                      ? "bg-blue-600 text-white"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                >
                  {page}
                </button>
              ))}
            </div>
          )}

          {/* Open Call Detail Modal */}
          <CampaignBatchModal
            isOpen={isModalOpen}
            onClose={closeModal}
            allBatches={campaignBatches}
          />
        </>
      )}
    </div>
  );
};

export default CampaignAnalytics;